<div class="d-flex justify-content-center align-items-center flex-fill flex-column login-viewport">
    <button
        class="theme-btn d-none d-sm-flex"
        mat-mini-fab
        (click)="themeToggle()"
        matTooltip="Toggle Theme"
        aria-label="toggle theme"
        color="primary">
        <mat-icon class="white">
            {{ themeService.currentTheme() === "arcus" ? "nights_stay" : "brightness_high" }}
        </mat-icon>
    </button>
    <mat-card class="no-pad login-card">
        <div id="logo-image"></div>
        <mat-card-content class="mat-padding">
            <button mat-stroked-button color="primary" (click)="login()" class="d-flex flex-fill w-100 mb-4">
                Login
            </button>
            <button mat-stroked-button color="primary" (click)="customerLogin()" class="d-flex flex-fill w-100">
                Customer Login
            </button>
        </mat-card-content>
    </mat-card>
    <div>
        <a href="" (click)="login()">Password Help</a>
        <fa-icon icon="ellipsis-vertical"></fa-icon>
        <a
            href="https://gohighway.com/onboarding/oauth/authorizations?response_type=code&state=1&client_id=34dedbbb-03e8-4b75-a808-acb5fcf310b8&scope=openid+email+phone+capacity+eld_verification+onboarding+tendering+monitoring+tracing+billing&redirect_uri=https%3A%2F%2Fgohighway.com%2Fonboarding%2Fcarrier%2Fthank-you">
            Carrier Registration
        </a>
        <fa-icon icon="ellipsis-vertical"></fa-icon>
        <a href="http://www.arcuslm.com">Information</a>
    </div>
</div>
